import {
  GetContactProjectTagsRequest,
  GetContactProjectTagsResponse,
  GetHubpostProjectTagsResponse,
  GetHubspotProjectTagsRequest,
  GetProjectTagsRequest,
  GetTagsResponse,
  UpdateProjectTagsRequest,
  UpdateProjectTagsResponse,
} from '@internal/types/api';

import { httpClient, mutationEndpoint, queryEndpoint } from '../system';

const getTags = queryEndpoint({
  entity: 'tags',
  queryKey: () => ['tags'],
  queryFn: (apiKey?: string, nextContext?) =>
    httpClient.auto<GetTagsResponse>({
      url: '/api/tags',
      method: 'GET',
      headers: {
        'auth-key': apiKey,
      },
      nextContext,
    }),
  defaultValue: [],
});

const getProjectTags = queryEndpoint({
  entity: 'projectTags',
  queryKey: ({ projectId }: GetProjectTagsRequest & { apiKey: string }) => [
    'project-tags',
    projectId,
  ],
  queryFn: ({ projectId, apiKey }, nextContext?) =>
    httpClient.auto<GetTagsResponse>({
      url: `/api/tags/projects/${projectId}`,
      method: 'GET',
      headers: {
        'auth-key': apiKey,
      },
      nextContext,
    }),
  defaultValue: [],
});

const getContactProjectTags = queryEndpoint({
  entity: 'contactProjectTags',
  queryKey: ({ contactKey }: GetContactProjectTagsRequest) => [
    'contact-project-tags',
    contactKey,
  ],
  queryFn: ({ contactKey }, nextContext?) =>
    httpClient.auto<GetContactProjectTagsResponse>({
      url: `/api/tags/contacts/${contactKey}`,
      method: 'GET',
      nextContext,
    }),
  defaultValue: { projectTags: {} },
});

const getHubspotProjectTags = queryEndpoint({
  entity: 'hubspotProjectTags',
  queryKey: ({ hubspotProjectId }: GetHubspotProjectTagsRequest) => [
    'hubspot-project-tags',
    hubspotProjectId,
  ],
  queryFn: ({ hubspotProjectId }, nextContext?) =>
    httpClient.auto<GetHubpostProjectTagsResponse>({
      url: `/api/tags/hubspot-projects/${hubspotProjectId}`,
      method: 'GET',
      nextContext,
    }),
  defaultValue: [],
});

const updateProjectTags = mutationEndpoint({
  actionName: 'updateProjectTags',
  mutationKey: ['update-project-tags'],
  mutationFn: ({
    apiKey,
    ...payload
  }: UpdateProjectTagsRequest & { apiKey: string }) =>
    httpClient.auto<UpdateProjectTagsResponse>({
      url: '/api/tags/projects/update',
      // TODO: Extend Method type
      method: 'PUT' as 'PATCH',
      data: payload,
      headers: {
        'auth-key': apiKey,
      },
    }),
  onSuccess: (queryClient, _, { projectId }) => {
    // Optimization? SetQueryData instead of invalidation
    queryClient.invalidateQueries({ queryKey: ['project-tags', projectId] });
  },
});

export {
  getContactProjectTags,
  getHubspotProjectTags,
  getProjectTags,
  getTags,
  updateProjectTags,
};
